module.exports = __webpack_public_path__ + "media/images/page/congratulation-tx-2323027adb06fc82e08a11a8e40ab5d6.png";